export class Input {
  constructor({ interact, details, close, home }) {
    this.keys = new Set();
    this.axis = { x: 0, y: 0 };
    this.locked = false;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.handlers = { interact, details, close, home };
    addEventListener(
      "keydown",
      (e) => {
        if (e.target.closest("input,textarea,select,[contenteditable]")) return;
        if (e.code === "Escape") {
          close();
          return;
        }
        if (!e.repeat && e.code === "KeyI") {
          details?.();
          return;
        }
        if (e.target.closest("button,a") && ["Enter", "Space"].includes(e.code))
          return;
        if (this.locked) return;
        if (
          ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Space"].includes(
            e.code,
          )
        )
          e.preventDefault();
        if (!e.repeat && ["Enter", "KeyE"].includes(e.code)) interact();
        if (!e.repeat && e.code === "KeyR") home();
        this.keys.add(e.code);
      },
      options,
    );
    addEventListener("keyup", (e) => this.keys.delete(e.code), options);
    addEventListener("blur", () => this.clear(), options);
    document.addEventListener("visibilitychange", () => this.clear(), options);
    const pad = document.querySelector("#joystick"),
      knob = pad.querySelector("span");
    let pointer = null;
    const reset = () => {
      pointer = null;
      this.axis = { x: 0, y: 0 };
      knob.style.transform = "";
      pad.classList.remove("active");
    };
    pad.addEventListener(
      "pointerdown",
      (e) => {
        if (this.locked) return;
        pointer = e.pointerId;
        pad.setPointerCapture(pointer);
        pad.classList.add("active");
        move(e);
      },
      options,
    );
    const move = (e) => {
      if (e.pointerId !== pointer) return;
      const r = pad.getBoundingClientRect(),
        dx = e.clientX - r.left - r.width / 2,
        dy = e.clientY - r.top - r.height / 2;
      const len = Math.hypot(dx, dy),
        limit = 34,
        factor = Math.min(1, limit / (len || 1));
      this.axis = { x: (dx * factor) / limit, y: (-dy * factor) / limit };
      knob.style.transform = `translate(${dx * factor}px,${dy * factor}px)`;
    };
    pad.addEventListener("pointermove", move, options);
    for (const type of ["pointerup", "pointercancel", "lostpointercapture"])
      pad.addEventListener(type, reset, options);
    this.resetPad = reset;
  }
  clear() {
    this.keys.clear();
    this.axis = { x: 0, y: 0 };
    this.resetPad?.();
  }
  setLocked(value) {
    this.locked = value;
    this.clear();
  }
  vector() {
    if (this.locked) return { x: 0, y: 0 };
    const k = this.keys;
    const x =
      this.axis.x +
      Number(k.has("KeyD") || k.has("ArrowRight")) -
      Number(k.has("KeyA") || k.has("ArrowLeft"));
    const y =
      this.axis.y +
      Number(k.has("KeyW") || k.has("ArrowUp")) -
      Number(k.has("KeyS") || k.has("ArrowDown"));
    const length = Math.max(1, Math.hypot(x, y));
    return { x: x / length, y: y / length };
  }
  dispose() {
    this.clear();
    this.controller.abort();
  }
}
